import styled from "styled-components";

const Title = styled.h2`
  color: ${(props) => props.theme.color.white};
`;

export default Title;
